<div class="login-page">
    <div class="login-shell">
        <section class="login-intro">
            <div class="intro-visual" aria-hidden="true">
                <span class="orb orb-1"></span>
                <span class="orb orb-2"></span>
                <span class="orb orb-3"></span>
                <div class="intro-badge">
                    <span class="wave"></span>
                    <span class="wave"></span>
                    <span class="wave"></span>
                    <i class="fa fa-mobile"></i>
                </div>
            </div>
            <div class="intro-copy">
                <h2>Verify your identity</h2>
                <p>Enter the multi-factor authentication code to complete your sign in securely.</p>
                <ul class="intro-points">
                    <li><i class="fa fa-shield"></i><span>Multi-factor authentication</span></li>
                    <li><i class="fa fa-mobile"></i><span>Code sent to your device</span></li>
                    <li><i class="fa fa-lock"></i><span>Extra layer of protection</span></li>
                </ul>
            </div>
        </section>

        <section class="login-panel">
            <div class="login-brand">
                <img src="assets/images/sovos-logo-dark.png" alt="Sovos">
            </div>
            <form [formGroup]="mfaForm" class="login-form" autocomplete="off" (ngSubmit)="verifyOtp()">
                <h1 class="login-title">Multi-factor authentication</h1>
                <p class="login-subtitle">Enter MFA code to complete sign in.</p>

                <div class="login-field">
                    <label for="mfaCode">MFA code</label>
                    <input type="text" class="login-input" formControlName="code" id="mfaCode"
                        placeholder="MFA Code" autocomplete="off">
                    <div *ngIf="isSubmitted">
                        <span class="login-error" *ngIf="mfaForm.get('code').errors">Please enter valid code</span>
                    </div>
                </div>

                <button type="submit" class="login-btn login-btn-primary login-btn-submit">VERIFY</button>
            </form>
        </section>
    </div>
</div>
